var nuevoPrecio = angular.module('preciosAdmin');

nuevoPrecio.controller('nuevoPrecioAdminController', ['$scope', '$routeParams', '$location', 'preciosAdminService', 'authenticationInfo', 'authenticationService', function ($scope, $routeParams, $location, preciosAdminService, authenticationInfo, authenticationService) {
    $scope.error = '';
    $scope.authentication = authenticationInfo;

    $scope.gestionPrecios = function () {
        $location.path("/admin/preciosAdmin");
    }

    $scope.guardarPrecios = function () {
        preciosAdminService.post($scope.descripcion, $scope.PrecioUnitario).then(function (response) {
                var result = response.data;
                alert("Precio añadido correctamente");
                $location.path("/admin/preciosAdmin");
                //$location.path("/Admin");
            }).catch(function (response) {
                $scope.error = preciosAdminService.obtenerPrimerErrorModelState(response.data);
                alert($scope.error);
            });
        }
    }]);